import React, { FC, useContext } from 'react';
import LocalizationContext from '../../../Localization/LanguageContext';
import { ILocalizationContext } from '../../../Localization/Models/ILocalizationContext';
import './index.css';

interface Props {}

const Footer: FC<Props> = ({}) => {
  const { getValue, setLocale } = useContext(
    LocalizationContext
  ) as ILocalizationContext;
  return (
    <>
      <div className='confirmation-footer py-2'>
        <div className='footer-content container px-0'>
          <div className='font-header-light'>
            <span id='FooterCopy'>© SAIF Corporation</span>
            <span className='footer-link-span'>
              <a
                id='FooterSiteLink'
                className='conf-header-link'
                href={getValue('Footer', 'WebsiteValue')}
                target='_blank'
              >
                {getValue('Footer', 'WebsiteDisplay')}
              </a>
            </span>
            <span className='footer-link-span'>
              <a
                id='FooterLegalLink'
                className='conf-header-link'
                href={getValue('Footer', 'LegalValue')}
                target='_blank'
              >
                {getValue('Footer', 'LegalDisplay')}
              </a>
            </span>
            <span className='footer-link-span'>
              <a
                id='FooterVerteranLink'
                className='conf-header-link'
                href={getValue('Footer', 'VeteransValue')}
                target='_blank'
              >
                {getValue('Footer', 'VeteransDisplay')}
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
